
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/leistungen/hausmeisterservice/hausmeisterservice-view.kpa`,
      template: `<section aria-labelledby="hero-headline" class="hausmeisterservice-view">
        <hero-section
            background-image="/images/hero/hausmeisterservice-hero.png"
           headline="Hausmeisterservice"
            subheadline="Hausmeisterservice mit FASE2"
            text="Wir kümmern uns um die Instandhaltung, Pflege und Verwaltung Ihrer Immobilie – alles aus einer Hand!"
            button-text="Jetzt kostenlos beraten lassen!"
            button-link="/home#kontakt"
        ></hero-section>

        <tool-bar></tool-bar>

        <div class="wrapper">
            <article aria-labelledby="uebersicht-hausmeisterservice">
                <h2 id="uebersicht-hausmeisterservice">Zuverlässige Hausmeisterservice für Ihre Immobilie</h2>
                <p>
                    Eine gut betreute Immobilie sorgt nicht nur für Werterhalt, sondern auch für zufriedene Bewohner und Nutzer. 
                    Mit unseren umfassenden Hausmeisterservice kümmern wir uns um die Instandhaltung, Pflege und Verwaltung Ihrer Immobilie - zuverlässig, professionell und aus einer Hand.
                </p>
            </article>

            <hex-text
                label="hausmeisterdienst"
                title="Hausmeisterdienst"
                image="/images/leistungen/hausmeisterservice/hausmeisterdienste.webp"
                left
            >
                <ul>
                    <li><strong>Regelmäßige Objektkontrollen:</strong> Überwachung und Inspektion von technischen Anlagen, Heizungen, Beleuchtung, Aufzügen und anderen Einrichtungen.</li>
                    <li><strong>Reparatur- und Wartungsarbeiten:</strong> Kleinere Reparaturen an Gebäuden, Türen, Fenstern und infrastrukturellen Einrichtungen.</li>
                    <li><strong>Sicherheits- und Funktionschecks:</strong> Kontrolle von Feuerlöschern, Notbeleuchtung, Rauchmeldern und Sicherheitsvorrichtungen in gemeinschaftlichen Bereichen.</li>
                    <li><strong>Beleuchtungskontrolle und Austausch:</strong> Überprüfung und Austausch defekter Leuchtmittel in Fluren, Treppenhäusern und Außenbereichen.</li>
                    <li><strong>Schlüssel- und Zugangskontrollen:</strong> Verwaltung und Kontrolle von Schlüsseln sowie Zutrittsberechtigungen für Bewohner oder externe Dienstleister.</li>
                    <li><strong>Notfallservice:</strong> Schnelle Reaktionszeiten bei Notfällen, wie Wasserrohrbrüchen, Stromausfällen oder anderen dringenden Reparaturen.</li>
                </ul>
            </hex-text>

            <hex-text
                label="abfallmanagement"
                title="Abfallmanagement"
                image="/images/leistungen/hausmeisterservice/muellentsorgung.webp"
                right
            >
                <ul>
                    <li><strong>Mülltonnen:</strong> Entleerung und ordnungsgemäße Entsorgung von Mülltonnen sowie regelmäßige Kontrolle der Müllentsorgungsbereiche.</li>
                    <li><strong>Entrümpelung:</strong> Fachgerechte Entrümpelung von Wohnungen, Kellern, Garagen und gewerblichen Objekten, inklusive Entsorgung von alten Möbeln und Gerätschaften.</li>
                </ul>
            </hex-text>

            <hex-text
                label="sonderaufgaben"
                title="Sonderaufgaben"
                image="/images/leistungen/hausmeisterservice/sonderaufgaben.webp"
                left
            >
                <ul>
                    <li><strong>Individuelle Dienstleistungen:</strong> Renovierungsarbeiten, Umzugsdienste oder die Betreuung von Außenanlagen bei besonderen Anlässen.</li>
                    <li><strong>Eindämmung von Schimmel und Feuchtigkeit:</strong> Identifikation und Behandlung von Schimmelbildung und Feuchtigkeitsproblemen in Gebäuden.</li>
                    <li><strong>Boden- und Fliesenpflege:</strong> Reparatur und Pflege von Böden, Fliesen und Teppichbelägen in Innen- und Außenbereichen.</li>
                    <li><strong>Fenster- und Türwartung:</strong> Wartung und Reparatur von Fenstern, Türen und Fensterbeschlägen für eine reibungslose Funktion.</li>
                </ul>
            </hex-text>

            <hex-text
                label="winterdienst"
                title="Winterdienst"
                image="/images/leistungen/hausmeisterservice/winterdienst.webp"
                right
            >
                <ul>
                    <li><strong>Schneeräumung:</strong> Entfernen von Schnee auf Gehwegen, Parkplätzen, Zufahrten und Treppenanlagen zur Gewährleistung der Sicherheit.</li>
                    <li><strong>Streuen von Gehwegen:</strong> Fachgerechtes Streuen von Salz oder anderen umweltfreundlichen Streumitteln auf Gehwegen und Parkplätzen zur Vermeidung von Glätte.</li>
                    <li><strong>Räumung von Einfahrten und Stellplätzen:</strong> Schnee- und Eisbeseitigung auf Einfahrten und Stellplätzen, um eine sichere Zufahrt zu gewährleisten.</li>
                    <li><strong>Zufahrtswege freihalten:</strong> Schneeräumung an Zufahrtsstraßen und Einfahrten für eine sichere Erreichbarkeit des Objekts.</li>
                    <li><strong>Räumung von Treppenhäusern:</strong> Schneeräumung und Streuen auf Treppenhäusern, Eingangsbereichen und öffentlichen Zugangswegen.</li>
                    <li><strong>Eisbeseitigung auf Dächern:</strong> Fachgerechte Entfernung von Schnee- und Eismassen von Dächern und Dachrinnen, um Schäden durch Eiszapfen oder Schneelasten zu vermeiden.</li>
                    <li><strong>Wasserabflussfreihaltung:</strong> Sicherstellung, dass Regenrinnen und Abflüsse nicht durch Schnee oder Eis blockiert sind.</li>
                    <li><strong>24/7 Bereitschaft:</strong> Winterdienst nach Bedarf und Notwendigkeit, auch außerhalb regulärer Arbeitszeiten für dringende Einsätze.</li>
                    <li><strong>Präventive Maßnahmen:</strong> Vorbeugende Maßnahmen zur Minimierung von Eisbildung, z.B. durch frühzeitiges Streuen bei drohendem Frost.</li>
                </ul>
            </hex-text>
        </div>
    </section>`,
      style: `hausmeisterservice-view .hausmeisterservice-view {
  margin: 0;
  padding: 0;
}
hausmeisterservice-view .hausmeisterservice-view .wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 64px 64px;
}
hausmeisterservice-view .hausmeisterservice-view .wrapper article {
  margin: 0 0 32px 0;
  padding: 0;
}
hausmeisterservice-view .hausmeisterservice-view .wrapper aside {
  margin: 0 0 32px 0;
  padding: 0;
}
@media (max-width: 992px) {
  hausmeisterservice-view .hausmeisterservice-view .wrapper {
    padding: 64px 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
};
 })()`
    };
  